import config from "../config/dbconfig";
const { db_name, db_version, db_tables } = config;
const indexedDB =
  window.indexedDB ||
  window.webkitIndexedDB ||
  window.mozIndexedDB ||
  window.msIndexedDB;
const dbConnect = indexedDB.open(db_name, db_version);
const getZskkDbInstance = _ =>
  new Promise((resolve, reject) => {
    dbConnect.onsuccess = e => {
      console.info("zskk db connect success");
      resolve(e.currentTarget.result);
    };
    dbConnect.onerror = e => {
      console.warn("zskk db connect warn:", e);
      reject(null);
    };
    dbConnect.onupgradeneeded = evt => {
      const db = evt.currentTarget.result;
      db_tables.forEach(db_table => {
        let { table_name, options, indexs } = db_table;
        if (!db.objectStoreNames.contains(table_name)) {
          console.info(
            "create table :" + table_name + "options is :",
            options,
            "indexs:",
            indexs
          );
          let objectStore = db.createObjectStore(table_name, options);
          if (objectStore && indexs && indexs.length > 0) {
            indexs.forEach(index => {
              let { index_key, filed_name, index_options } = index;
              objectStore.createIndex(index_key, filed_name, index_options);
            });
          }
        }
      });
    };
  }).catch(function(reason) {
    console.log("catch:", reason);
  });
export default getZskkDbInstance;
